<template>
    <section id="video" v-if="video!=null">
        <iframe style="min-height: 600px;" width="100%" height="100%" v-bind:src="embedUrl" frameborder="0" allowfullscreen></iframe>
    </section>
</template>

<script>
    let _ = require('lodash');
    export default {
        data    : function(){
            return {
                video : null
            }
        },
        computed :
        {
            currentLanguage : function()
            {
                return this.$language;
            },
            embedUrl : function(){
                return `https://www.youtube.com/embed/${this.video.url.split('?v=')[1]}`;
            }
        },
        created : function()
        {
            let self = this;
            this.unsubscribe  = this.$store.subscribe((mutation,state) => {
                self.$language = self.$store.state.language;
                if( !_.isNull(self.$store.getters.config) && ('url' in self.$store.getters.config.video) )
                {
                    self.video = self.$store.getters.config.video;
                }
            });
        },
        mounted : function()
        {
            let self = this;
            let config = this.$store.getters.config;
            if( !_.isNull(config) && ('url' in self.$store.getters.config.video) )
            {
                self.video = self.$store.getters.config.video;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Video.vue?2e008420